module.exports = __webpack_public_path__ + "01c400f24217b891a318505498a6627a.svg";